var map = {
	"./1.jpeg": "RHmn",
	"./2.jpg": "Nqcz",
	"./3.jpg": "JdNb",
	"./4.jpg": "CnK1",
	"./5.jpg": "rPNb",
	"./6.jpg": "b9zc",
	"./7.jpg": "hs7u",
	"./8.jpg": "CT13",
	"./gxzs.jpg": "/ob4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+eri";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/soft nonrecursive \.(jpg|jpeg|png)$
// module id = +eri
// module chunks = 13